import { useState, useEffect, useRef, useCallback } from 'react';
import { MapPin } from '../../../server/properties/propertyTypes';
import { getMapPinsApi } from '../../../services/propertyApiClient';
import { buildBackendFilterPayload, BrokerFilterHookInput } from '../../../hooks/propertyFilterPayloadBuilder';

export interface UseMapPinsOptions extends BrokerFilterHookInput {
  spatialFilter?: any;
  enabled?: boolean;
}

export function useMapPins(options: UseMapPinsOptions) {
  const [pins, setPins] = useState<MapPin[]>([]);
  const [isLoadingPins, setIsLoadingPins] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const activeReqId = useRef(0);

  const fetchPins = useCallback(async () => {
    if (options.enabled === false) return;
    const reqId = ++activeReqId.current;
    setIsLoadingPins(true);
    setError(null);

    try {
      const payload = buildBackendFilterPayload(options, 1, 50000);
      const data = await getMapPinsApi(payload);
      if (reqId === activeReqId.current) {
        setPins(data || []);
      }
    } catch (err: any) {
      if (reqId === activeReqId.current) {
        console.error('[useMapPins] Error loading map pins:', err);
        setError(err?.message || 'Error cargando pines del mapa');
      }
    } finally {
      if (reqId === activeReqId.current) {
        setIsLoadingPins(false);
      }
    }
  }, [
    options.propertyCodeFilter,
    options.ubicacionFilter,
    options.propertyTypeFilter,
    options.estrategiaComercialFilter,
    options.ownerFilter,
    options.roomsFilter,
    options.bathsFilter,
    options.garagesFilter,
    options.priceFilter,
    options.areaFilter,
    options.estratoFilter,
    options.withElevatorFilter,
    options.onlyRecentFilter,
    options.spatialFilter,
    options.searchMode,
    options.appUser,
    options.enabled,
  ]);

  useEffect(() => {
    fetchPins();
  }, [fetchPins]);

  return {
    pins,
    isLoadingPins,
    error,
    refreshPins: fetchPins,
  };
}
